import * as React from "react";
import { cn } from "@/lib/utils";

interface FormSectionProps {
  title: string;
  description?: string;
  className?: string;
}

export function FormSection({ title, description, className }: FormSectionProps) {
  return (
    <div className={cn("space-y-2", className)}>
      <h3 className="text-lg font-medium">{title}</h3>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
    </div>
  );
}
